/* SilverLuxe theme JS — vanilla, no dependencies */
(function () {
  'use strict';

  /* ---------- Hero slider ---------- */
  function initHeroSlider() {
    const slides = document.querySelectorAll('.hero-slide');
    const dots = document.querySelectorAll('.hero-dot');
    if (!slides.length) return;
    let current = 0;
    function goSlide(n) {
      slides[current].classList.remove('active');
      if (dots[current]) dots[current].classList.remove('active');
      current = n;
      slides[current].classList.add('active');
      if (dots[current]) dots[current].classList.add('active');
    }
    dots.forEach((dot, i) => dot.addEventListener('click', () => goSlide(i)));
    if (slides.length > 1) {
      setInterval(() => goSlide((current + 1) % slides.length), 5000);
    }
  }

  /* ---------- FAQ accordion ---------- */
  function initFAQ() {
    document.querySelectorAll('.faq-q').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.faq-item');
        const wasOpen = item.classList.contains('open');
        item.parentElement.querySelectorAll('.faq-item').forEach((i) => i.classList.remove('open'));
        if (!wasOpen) item.classList.add('open');
      });
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    const toggle = document.querySelector('.menu-toggle');
    const links = document.querySelector('.nav-links');
    if (!toggle || !links) return;
    toggle.addEventListener('click', () => links.classList.toggle('mobile-open'));
  }

  
  // /* ---------- Product grid category filter (collection page) ---------- */
  // function initFilterTabs() {
  //   document.querySelectorAll('.filter-tab').forEach((btn) => {
  //     btn.addEventListener('click', () => {
  //       const cat = btn.dataset.cat;
  //       document.querySelectorAll('.filter-tab').forEach((t) => t.classList.remove('active'));
  //       btn.classList.add('active');
  //       document.querySelectorAll('.prod-card').forEach((card) => {
  //         card.style.display = cat === 'all' || card.dataset.cat === cat ? '' : 'none';
  //       });
  //     });
  //   });
  // }

  /* ---------- Quantity steppers (product page + cart drawer + cart page) ---------- */
  function initQtySteppers() {
    document.addEventListener('click', (e) => {
      const minus = e.target.closest('[data-qty-minus]');
      const plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      const wrap = (minus || plus).closest('.qty-stepper');
      const input = wrap.querySelector('input[type="number"], input.qty-input');
      if (!input) return;
      let val = parseInt(input.value, 10) || 1;
      val = plus ? val + 1 : Math.max(1, val - 1);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Cart drawer ---------- */
  const cartDrawer = {
    el: null,
    overlay: null,
    init() {
      this.el = document.querySelector('[data-cart-drawer]');
      this.overlay = document.querySelector('[data-cart-overlay]');
      if (!this.el) return;
      document.querySelectorAll('[data-cart-open]').forEach((b) =>
        b.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        })
      );
      document.querySelectorAll('[data-cart-close]').forEach((b) =>
        b.addEventListener('click', () => this.close())
      );
      if (this.overlay) this.overlay.addEventListener('click', () => this.close());

      // line item qty change inside drawer -> update cart
      this.el.addEventListener('change', (e) => {
        if (e.target.matches('[data-line-qty]')) {
          const key = e.target.dataset.lineQty;
          this.updateLine(key, e.target.value);
        }
      });
      this.el.addEventListener('click', (e) => {
        const removeBtn = e.target.closest('[data-line-remove]');
        if (removeBtn) {
          this.updateLine(removeBtn.dataset.lineRemove, 0);
          return;
        }
        const couponToggle = e.target.closest('[data-coupon-toggle]');
        if (couponToggle) {
          const panel = this.el.querySelector('[data-coupon-panel]');
          if (panel) {
            panel.hidden = !panel.hidden;
            couponToggle.classList.toggle('open', !panel.hidden);
            if (!panel.hidden) panel.querySelector('[data-coupon-input]').focus();
          }
          return;
        }
        const couponApply = e.target.closest('[data-coupon-apply]');
        if (couponApply) {
          const input = this.el.querySelector('[data-coupon-input]');
          const code = input ? input.value.trim() : '';
          if (!code) {
            if (input) input.focus();
            return;
          }
          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart';
          return;
        }
        const prev = e.target.closest('[data-recommend-prev]');
        const next = e.target.closest('[data-recommend-next]');
        if (prev || next) {
          cartRecommend.slide(next ? 1 : -1);
        }
      });
      this.el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && e.target.matches('[data-coupon-input]')) {
          e.preventDefault();
          this.el.querySelector('[data-coupon-apply]').click();
        }
      });
      cartRecommend.load(this.el);
      this.bindScrollHint();
    },
    bindScrollHint() {
      const itemsEl = this.el.querySelector('[data-cart-items]');
      const hintEl = this.el.querySelector('[data-scroll-hint]');
      if (!itemsEl || !hintEl) return;
      const update = () => {
        const hasOverflow = itemsEl.scrollHeight > itemsEl.clientHeight + 4;
        const nearBottom = itemsEl.scrollTop + itemsEl.clientHeight >= itemsEl.scrollHeight - 10;
        hintEl.classList.toggle('visible', hasOverflow && !nearBottom);
      };
      itemsEl.addEventListener('scroll', update);
      requestAnimationFrame(update);
      window.addEventListener('resize', update);
    },
    open() {
      this.el.classList.add('open');
      if (this.overlay) this.overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    },
    close() {
      this.el.classList.remove('open');
      if (this.overlay) this.overlay.classList.remove('open');
      document.body.style.overflow = '';
    },
    async refresh() {
      try {
        const res = await fetch('/?section_id=cart-drawer');
        const html = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawer = doc.querySelector('[data-cart-drawer]');
        if (newDrawer) {
          this.el.innerHTML = newDrawer.innerHTML;
        }
        this.updateBubble();
        cartRecommend.load(this.el);
        this.bindScrollHint();
      } catch (err) {
        console.error('Cart refresh failed', err);
      }
    },
    async updateBubble() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      } catch (err) {
        /* noop */
      }
    },
    async updateLine(key, quantity) {
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: parseInt(quantity, 10) }),
        });
        await this.refresh();
      } catch (err) {
        console.error('Cart update failed', err);
      }
    },
  };

  /* ---------- Cart drawer "You may also like" recommendations ---------- */
  const cartRecommend = {
    index: 0,
    products: [],
    container: null,
    async load(rootEl) {
      this.container = rootEl.querySelector('[data-cart-recommend]');
      if (!this.container) return;
      const productId = this.container.dataset.baseProductId;
      if (!productId) {
        this.container.innerHTML = '';
        return;
      }
      try {
        const res = await fetch(
          `/recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=6&intent=related`
        );
        const data = await res.json();
        this.products = (data.products || []).slice(0, 6);
        this.index = 0;
        this.render();
      } catch (err) {
        console.error('Recommendations failed', err);
        this.container.innerHTML = '';
      }
    },
    render() {
      if (!this.container || !this.products.length) {
        if (this.container) this.container.innerHTML = '';
        return;
      }
      const p = this.products[this.index];
      const price = (p.price / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR' });
      const compare =
        p.compare_at_price && p.compare_at_price > p.price
          ? (p.compare_at_price / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR' })
          : null;
      const dots = this.products
        .map((_, i) => `<span class="cart-recommend__dot${i === this.index ? ' active' : ''}"></span>`)
        .join('');
      this.container.innerHTML = `
        <div class="cart-recommend__label">You may also like</div>
        <div class="cart-recommend__row">
          <button type="button" class="cart-recommend__arrow" data-recommend-prev aria-label="Previous">&lsaquo;</button>
          <a href="${p.url}" class="cart-recommend__card">
            <img src="${p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : ''}" alt="${p.title.replace(/"/g, '&quot;')}" loading="lazy">
            <div class="cart-recommend__info">
              <div class="cart-recommend__title">${p.title}</div>
              <div class="cart-recommend__price">${compare ? `<span class="cart-recommend__compare">${compare}</span>` : ''}${price}</div>
            </div>
          </a>
          <button type="button" class="cart-recommend__arrow" data-recommend-next aria-label="Next">&rsaquo;</button>
        </div>
        <div class="cart-recommend__dots">${dots}</div>
      `;
    },
    slide(dir) {
      if (!this.products.length) return;
      this.index = (this.index + dir + this.products.length) % this.products.length;
      this.render();
    },
  };

  /* ---------- AJAX Add to cart ---------- */
  function initAddToCart() {
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('form[data-add-to-cart-form]');
      if (!form) return;
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding…';
      }
      try {
        const formData = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });
        const data = await res.json();
        if (data.status) {
          // Shopify error response (e.g. sold out)
          if (btn) btn.textContent = data.description || 'Unavailable';
          setTimeout(() => {
            if (btn) {
              btn.disabled = false;
              btn.textContent = originalText;
            }
          }, 1800);
          return;
        }
        await cartDrawer.refresh();
        cartDrawer.open();
        if (btn) {
          btn.textContent = 'Added ✓';
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = originalText;
          }, 1400);
        }
      } catch (err) {
        console.error('Add to cart failed', err);
        if (btn) {
          btn.disabled = false;
          btn.textContent = originalText;
        }
      }
    });
  }

  /* ---------- Product gallery thumbnail swap ---------- */
  function initProductGallery() {
    document.querySelectorAll('.product-gallery__thumbs img').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const main = document.querySelector('.product-gallery__main img');
        if (!main) return;
        main.src = thumb.dataset.full || thumb.src;
        document.querySelectorAll('.product-gallery__thumbs img').forEach((t) => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHeroSlider();
    initFAQ();
    initMobileMenu();
    initQtySteppers();
    cartDrawer.init();
    cartDrawer.updateBubble();
    initAddToCart();
    initProductGallery();
  });
})();
